import { updateNotification } from "./utils/updateNotification";
import { events } from "@planzone/events";
import { createStateReducer } from "../utils/createStateReducer";
import { initialState } from "./initialState";
import { pushIf } from "./utils/pushIf";

const reduceMoveOrganizationalUnitState = createStateReducer(initialState, {
  [events.moveOrganizationalUnitSucceeded]: (state) => ({
    ...state,
    queue: updateNotification(
      {
        key: "moveOrganizationalUnit",
        flags: ["success"],
        args: { success: "true" },
      },
      state.queue,
    ),
  }),
  [events.moveOrganizationalUnitFailed]: (state, { error }) => ({
    ...state,
    queue: updateNotification(
      {
        key: "moveOrganizationalUnit",
        flags: pushIf({
          ...error,
          failure: !Object.values(error).includes(true),
        }),
        args: { failure: "true" },
      },
      state.queue,
    ),
  }),
});

export { reduceMoveOrganizationalUnitState };
